export default __webpack_public_path__ + "static/media/plant.fe24cbae.JPG";